import {useCallback, useEffect, useState} from 'react';
import {HttpError, Problem, State} from '@synako/halitrek';
import {LigneDePanierDesc} from 'api-types/ffconnect-hal';
import {useClient} from '@/haligator-factory';
import {useHalState} from '@synako/haligator';
import {UniteQuantite} from 'api-types/ffconnect';
import {useLigneDePanierCommands} from 'ff-common';
import {TextToastCommand} from 'ff-common/src/types/TextToastCommand';
import {useDefaultOnError} from '../useDefaultOnError';
import {ModaleErreurDisponibilite} from '@/domains/cadencier/components/ModaleErreurDisponibilite.tsx';

export const useSelectionParColis = (
  ligneDePanier: State<LigneDePanierDesc> | undefined,
  code_article: string | undefined,
  quantite_colis_entier: number | undefined,
  textToast: TextToastCommand,
) => {
  //Selection par defaut:
  // - X Check si une ligne de panier en cours est en mode colis
  // - X Si quantite_colis_entier n'est pas défini, on ne peut pas selectionner par colis
  // - X Sinon, check les preferences utilisateurs
  // - > Sinon, unitaire

  const {state: preferences} = useHalState(useClient().follow('preferences'));
  const [selectionParColis, setStateSelectionParColis] = useState<boolean>(
    ligneDePanier ? ligneDePanier.data.commande_en == 'colis' : false,
  ); //FIXME

  useEffect(() => {
    if (!preferences) return;
    if (!code_article) return;
    if (!quantite_colis_entier) return;
    const ColisParDefaut =
      preferences.data.articles_en_colis?.includes(code_article);
    if (ColisParDefaut)
      setStateSelectionParColis(
        //Applique l'etat de la ligne en priorité, sinon la valeur par defaut
        ligneDePanier
          ? ligneDePanier.data.commande_en == 'colis'
          : ColisParDefaut,
      );
  }, [
    preferences,
    setStateSelectionParColis,
    code_article,
    ligneDePanier,
    quantite_colis_entier,
  ]);

  const onError = useDefaultOnError(textToast);
  const {switchUnite} = useLigneDePanierCommands(
    ligneDePanier,
    textToast,
    onError,
    ModaleErreurDisponibilite,
  );
  const setSelectionUnite = useCallback(
    async (unite: UniteQuantite) => {
      setStateSelectionParColis(unite === 'colis');
      if (ligneDePanier) {
        try {
          return await switchUnite.submitAsync({unite});
        } catch (error) {
          onError(error as HttpError | Problem);
        }
      }
      return;
    },
    [ligneDePanier, switchUnite, onError],
  );

  return {selectionParColis, setSelectionUnite, switchUnite};
};
